import { render, staticRenderFns } from "./enterpriseCertification.vue?vue&type=template&id=ff8f4f9c&scoped=true"
import script from "./enterpriseCertification.vue?vue&type=script&lang=js"
export * from "./enterpriseCertification.vue?vue&type=script&lang=js"
import style0 from "./enterpriseCertification.vue?vue&type=style&index=0&id=ff8f4f9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8f4f9c",
  null
  
)

export default component.exports